import { createSlice } from '@reduxjs/toolkit'
import { moveDiceTarget } from '../GameTheme/SpaceDiceGame/pixi-js-scripts/slider'
import { BET_RESULT } from 'utils/constants/index'
import { getMyBetsSpaceDiceGame, getTopBetsSpaceDiceGame, placedBetSpaceDiceGame } from './spaceDiceGame.thunk'
import { plus, minus } from 'number-precision'

const initialState = {
  betHistoryData: null,
  betResult: null,
  resultData: [],
  placedBetDiceGameData: [],
  topBetsData: [],
  myBetsData: null,
  myBetsLoading: false,
  topBetsLoading: false,
  sliderData: {
    left: 2500,
    center: 5000,
    right: 7499
  },
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0
}

const {
  actions: {
    setPlacedBetsData,
    setSliderData,
    setDiceBetHistory,
    resetDiceGameResult,
    setSpaceDiceLossCount,
    setSpaceDiceWinsCount,
    setSpaceDiceProfit,
    setSpaceDiceWagered,
    resetLiveStats
  },
  reducer
} = createSlice({
  name: 'spaceDiceGame',
  initialState,
  reducers: {
    setPlacedBetsData: (state, action) => {
      return {
        ...state,
        betHistoryData: action.payload
      }
    },
    setSliderData: (state, action) => {
      return {
        ...state,
        sliderData: {
          ...state.sliderData,
          ...action.payload
        }
      }
    },
    setDiceBetHistory: (state, action) => ({
      ...state,
      diceBetHistory: action?.payload
    }),
    resetDiceGameResult: (state, action) => ({
      ...state,
      betResult: null
    }),
    setDiceWinsCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setDiceLossCount: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setDiceProfit: (state, action) => {
      return {
        ...state,
        profit: plus(state.profit, minus(action.payload?.winningAmount ?? 0, action.payload?.betAmount ?? 0))
      }
    },
    setDiceWagered: (state, action) => {
      return {
        ...state,
        wagered: plus(state.wagered, action.payload)
      }
    },
    resetLiveStats: (state, action) => {
      return ({
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      })
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTopBetsSpaceDiceGame.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBetsSpaceDiceGame.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload.topBets,
          topBetsLoading: false
        }
      })
      .addCase(getMyBetsSpaceDiceGame.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true
        }
      })
      .addCase(getMyBetsSpaceDiceGame.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false
        }
      })
      .addCase(placedBetSpaceDiceGame.fulfilled, (state, action) => {
        moveDiceTarget(action.payload?.winningNumber || 5000)
        const profit = plus(state.profit, minus(action.payload?.winningAmount ?? 0, action.payload?.betAmount ?? 0))
        const wagered = plus(state.wagered, action.payload?.betAmount)
        const wins = plus(state.wins, action.payload?.result === BET_RESULT.WON ? 1 : 0)
        const losses = plus(state.losses, action.payload?.result === BET_RESULT.LOST ? 1 : 0)
        return {
          ...state,
          placedBetDiceGameData: action.payload,
          profit,
          wagered,
          wins,
          losses,
          myBetsData: {
            count: state?.myBetsData?.count + 1,
            rows: [action.payload, ...state?.myBetsData?.rows]
          }
        }
      })
  }
})

export default reducer
export {
  setPlacedBetsData,
  setSliderData,
  setDiceBetHistory,
  resetDiceGameResult,
  resetLiveStats,
  setSpaceDiceLossCount,
  setSpaceDiceWinsCount,
  setSpaceDiceProfit,
  setSpaceDiceWagered
}
